import {
  HYDRATED_QUERY_OPTIONS,
  hotStoreListQuery,
  storeListQuery,
} from '@/lib/page-queries';
import {
  fetchRecommendedStore,
  recommendedStoreQueryKey,
} from '@/lib/recommended-store';
import { useQuery } from '@tanstack/react-query';
import { ApiResponse, QUERY_KEYS } from '../base-api';
import {
  getKeywordList,
  getStoreContactList,
  getStoreDetail,
  getStoreNameList,
} from '../store.service';
import {
  GetStoreListParams,
  KeywordEntity,
  StoreContactEntity,
  StoreEntity,
  StoreListResponse,
} from '../types/store.type';

export const useStoreContactList = (type: string) => {
  return useQuery<ApiResponse<StoreContactEntity[]>>({
    queryKey: [QUERY_KEYS.STORE, 'contacts', type],
    queryFn: () => getStoreContactList(type),
  });
};

export const useStoreList = (params?: GetStoreListParams) => {
  return useQuery<ApiResponse<StoreListResponse>>({
    ...storeListQuery(params),
    ...HYDRATED_QUERY_OPTIONS,
  });
};

/**
 * 학원 목록 상단 추천 실내운전연습장 1곳(규칙은 lib/recommended-store).
 * 반경 내 매장이 없으면 null. 지역이 바뀌는 동안 이전 결과를 유지해 배너 깜빡임을 줄인다.
 */
export const useRecommendedStore = (region?: string) => {
  return useQuery<StoreEntity | null>({
    queryKey: recommendedStoreQueryKey(region),
    queryFn: () => fetchRecommendedStore(region as string),
    enabled: !!region,
    placeholderData: (previous) => previous,
  });
};

export const useHotStoreList = () => {
  return useQuery<ApiResponse<StoreEntity[]>>({
    ...hotStoreListQuery(),
    ...HYDRATED_QUERY_OPTIONS,
  });
};

export const useStoreDetail = (id: number) => {
  return useQuery<ApiResponse<StoreEntity>>({
    queryKey: [QUERY_KEYS.STORE, QUERY_KEYS.DETAIL, id],
    queryFn: () => getStoreDetail(id),
    enabled: !!id,
  });
};

export const useKeywordList = () => {
  return useQuery<ApiResponse<KeywordEntity[]>>({
    queryKey: [QUERY_KEYS.STORE, 'keywords'],
    queryFn: getKeywordList,
  });
};

export const useStoreNameList = () => {
  return useQuery<ApiResponse<StoreEntity[]>>({
    queryKey: [QUERY_KEYS.STORE, 'name-list'],
    queryFn: getStoreNameList,
  });
};
